import api from "helpers/api";


export const getUserList = async (data) => {
    try {
        const response = await api.post("/ipms/userList", {
            userID: data.id,
            keyword: data.keyword,
        });
        console.log('response', response);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const getParkingList = async (data) => {
    try {
        const response = await api.post("/ipms/parkingList", {
            userID: "",
        });
        console.log('response', response);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

export const loginAttendance = async (data) => {
    try {
        const response = await api.post("/facility/login_attendance", {
            parkingId: data.parkingId,
            userId: data.userId,
            attendanceNote: data.attendanceNote
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const logoutAttendance = async (data) => {
    try {
        const response = await api.post("/facility/logout_attendance", {
            parkingId: data.parkingId,
            userId: data.userId,
            leaveWorkNote: data.leaveWorkNote
        });
        return response;
    } catch (error) {
        throw error;
    }
}


export const UpdateUser = async (param: any = {}) => {
    try {
        const response = await api.post("/facility/user_update", param);
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || error.message || "Failed to fetch car list");
    }
}

export const getUserWorkingTime = async (data) => {
    try {
        const response = await api.post("/facility/user_working_time", {
            userId: data.userId,
            parkingId: data.parkingId
        });
        return response;
    } catch (error) {
        console.error("Error fetch data", error.response?.data || error.message);
        return null;
    }
}

